module.exports = __webpack_public_path__ + "97de619e9a5901865b072df9c907d4a3.png";